module.exports = __webpack_public_path__ + "7a1f19391cc2d0cae74a3831db288ce2.svg";